import React from 'react';
import '../template-file-css/document-file-template.css';



export const LaGeneral_TeleHealthConsentForm = ({
    itemsRef,
    showErrorFor,

}) => {

    return (
        <form id='LaGeneral_TeleHealthConsentForm' className='file-pdf-document'>
            <div className='file-template'>


                <p className='w-750'><h3>GENERAL Informed Consent Form for Telemedicine/Telehealth</h3></p>

                <p className='w-750'>
                    <b>PURPOSE:</b> The purpose of this form is to obtain your consent to participate in a telehealth consultation in connection with the following service(s): &nbsp;
                    <input type='text' id='txtService' name='txtService' className='add-only w-250 custom-add-only' />. via TELEHEALTH, including streaming video and audio feeds, with recording.
                </p>

                <p className='w-750'>
                    <b>RATIONALE:</b>
                </p>
                <p className='w-750'>
                    To provide quality, safe services during the COVID-19 declared emergency. As in-person intervention is the only approved method for providing the aforementioned services under normal circumstances, an allowance to deliver these services via an alternate method required approval from the Centers for Medicare and Medicaid Services (CMS).
                </p>
                <p className='w-750'>
                    <b>NATURE OF TELEHEALTH CONSULT:</b> During the telehealth consultation:
                </p>

                <p className='w-750'>
                    <ol type='a'>
                        <li>Details of your behavioral health, medical history, examinations, assessments, evaluations and/or tests may be discussed with other health professionals through the use of interactive video, audio, and telecommunication technology.
                        </li>
                        <li>A physical examination of you may take place. (medical providers)
                        </li>
                        <li>A non-medical technician is not likely but may be present in the telehealth studio to aid in the video transmission.
                        </li>
                        <li>Video, audio and/or photo recordings may be taken of you during the procedure(s) or service(s)
                        </li>
                    </ol>
                </p>
                <p className='w-750'>
                    <b>ALTERNATIVES TO TELEMEDICINE/TELEHEALTH:</b>
                </p>
                <p className='w-750'>
                    IF in-person visits between specialized behavioral health practitioners (licensed and/or unlicensed) are considered medically necessary, and IF both the provider/staff member AND participant/participant's family agrees that such encounters are necessary and safe, you will be contacted prior to the visit and all parties should adhere to 'DO THE FIVE:'
                </p>
                <p className='w-750'>
                    1. HANDS: Wash them often.
                </p>
                <p className='w-750'>
                    2. ELBOW: Cough into it.
                </p>
                <p className='w-750'>
                    3. FACE: Don't touch it.
                </p>
                <p className='w-750'>
                    4. FEET: Stay more than 6 feet apart.
                </p>
                <p className='w-750'>
                    5. FEEL sick: Stay home.
                </p>
                <p className='w-750'>
                    <b>MEDICAL INFORMATION & RECORDS:</b>All existing laws regarding your access to medical information and copies of your medical records apply to this telehealth consultation. Please note, not all telecommunications are recorded and stored. Additionally, dissemination of any patient identifiable images or information for this telehealth interaction to researchers or other entities shall not occur without your consent.
                </p>
                <p className='w-750'>
                    <b>CONFIDENTIALITY:</b>Reasonable and appropriate efforts have been made to eliminate any confidentiality risks associated with the telehealth consultation, and all existing confidentiality protections under federal and &nbsp;
                    <input type='text' id='txtProtections' name='txtProtections' className='add-only w-250 custom-add-only' /> &nbsp;
                    state law apply to information disclosed during this telehealth consultation. Confidentiality still applies for services delivered through telemedicine/telehealth. Sessions will not be recorded without consent from the recipient or authorized representative.
                </p>
                <p className='w-750'>
                    <b>RIGHTS:</b> You may withhold or withdraw consent to the telehealth consultation at any time without affecting your right to future care or treatment or risking the loss or withdrawal of any program benefits to which you would otherwise be entitled.
                </p>
                <p className='w-750'>
                    <b>DISPUTES:</b> You agree that any dispute arriving from the telehealth consult will be resolved in the state of &nbsp;
                    <input type='text' id='txtState' name='txtState' className='add-only w-250 custom-add-only' />, and that &nbsp;
                    <input type='text' id='txtState1' name='txtState1' className='add-only w-250 custom-add-only' /> &nbsp;State law shall apply to all disputes.
                </p>
                <p className='w-750'>
                    <b>RISKS, CONSEQUENCES & BENEFITS:</b> You have been advised of all the potential risks, consequences and benefits of telehealth. Your health care practitioner has discussed with you the information provided above. You have had the opportunity to ask questions about the information presented on this form and the telehealth consultation. All your questions have been answered, and you understand the written information provided above.
                </p>
                <p className='w-750'>
                    I agree to participate in a telehealth consultation for the service(s) described above.
                </p>


                <table>
                    <tr>
                        <td className='signature w-300'>&nbsp; </td>
                        <td className='signature w-300'>&nbsp; </td>
                        <td className='signature w-150'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-300'>Signature:</td>
                        <td className='small w-300'>Printed Name:</td>
                        <td className='small w-150'>Date:</td>
                    </tr>
                </table>

                <p className='w-750'>
                    IF 18 YEARS OR UNDER PARENT OR GUARDIAN MUST SIGN:
                </p>

                <table>
                    <tr>
                        <td className='signature w-300'>&nbsp; </td>
                        <td className='signature w-300'>&nbsp; </td>
                        <td className='signature w-150'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-300'>Parent/Guardian Signature:</td>
                        <td className='small w-300'>Relationship to Participant:</td>
                        <td className='small w-150'>Date:</td>
                    </tr>
                </table>

            </div>
        </form >

    )
}











